<template>
  <vs-popup
    class="deleteDialog"
    title="确认手动上账"
    :active="dialogShow"
    button-close-hidden
  >
    <p>上账后，该笔金额将转至商户钱包</p>
    <div class="footer">
      <vs-button
        type="border"
        color="primary"
        @click="cancel"
      >取消</vs-button>
      <vs-button
        type="filled"
        color="primary"
        @click="confirm"
      >确定</vs-button>
    </div>
  </vs-popup>
</template>

<script>
    export default {
        name: "deleteDialog",
      props: {
        dialogShow: {
          type: Boolean,
          default: false
        },
      },
      methods: {
        confirm() {
          this.$emit('confirm');
        },
        cancel(){
          this.$emit('cancel');
        }
      },
    }
</script>

<style lang="scss">
  @import "../../assets/scss/variable";
.deleteDialog {
  .vs-popup {
    width: 276px;
    .vs-popup--header {
      background-color: $themeColor;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      .vs-popup--title {
        border-radius: 0;
        h3 {
          color: #ffffff;
          padding-top: 15px;
          padding-bottom: 15px;
        }
      }
    }
  }
  .footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 2rem;
  }
}
</style>
